/* /mtg-deck-analyzer — paste a list, get the curve, colors, a Commander bracket estimate (free) and the
 * ratio check against the format's template (free account; signed-out visitors go through sign-in and
 * come back to a finished analysis). Hands the list on to the AI builder, the dashboard, the odds tool
 * and the budget swaps tool. Logic lives in assets/js/tools/core.js.
 */
import "../lib/site.js";
import "../tools/panel.js";

(function () {
  "use strict";

  var KD = window.KD, T = KD.tools, esc = KD.esc;
  var out = KD.$("[data-out]");
  if (!out) return;
  var emptyHTML = out.innerHTML;
  var FORMAT = { commander: "Commander", constructed: "60-card", limited: "40-card" };
  var HEX = { W: "#efe0a8", U: "#4c9be8", B: "#9a84c4", R: "#e5645a", G: "#43c28b", C: "#9aa7b5" };
  var NAME = { W: "White", U: "Blue", B: "Black", R: "Red", G: "Green", C: "Colorless" };
  var RATIOS = [["lands", "Lands"], ["ramp", "Ramp"], ["draw", "Card draw"], ["removal", "Targeted removal"], ["wipe", "Board wipes"]];
  var GAPWORD = { lands: "lands", ramp: "ramp", draw: "card draw", removal: "removal", wipe: "board wipes" };
  var last = null;

  var panel = KD.toolPanel({ key: "kraken_pending_analysis", example: KD.EXAMPLE_CMD, run: run, clear: function () { out.innerHTML = emptyHTML; last = null; } });

  async function run(text, reason) {
    var parsed = T.parseDecklist(text);
    if (!parsed.rows.length) { panel.status("No card lines found. Paste one card per line, like “1 Sol Ring”."); return; }
    panel.status("Looking up " + parsed.rows.length + " cards on Scryfall…", true);
    var res;
    try { res = await T.resolveCards(parsed.rows, function (d, t) { panel.status("Looking up cards… " + d + " of " + t, true); }); }
    catch (e) { panel.status("Scryfall didn't answer. Try again in a moment."); return; }
    panel.status("");
    if (!res.matched.length) {
      out.innerHTML = '<div class="tool__empty"><svg class="i" aria-hidden="true"><use href="#i-alert"/></svg><h2>No cards matched</h2><p>Check the spelling, one card per line.</p></div>' + KD.unmatchedHTML(res.unmatched);
      return;
    }
    var a = T.analyze(res.matched);
    last = { a: a, parsed: parsed };
    paint(a, res);
    KD.ga("analyzer_run", { reason: reason, format: a.format, cards: a.totalCards, bracket: a.bracket ? a.bracket.level : 0 });
    if (reason !== "handoff" || KD.mobile()) out.scrollIntoView({ behavior: KD.reduce ? "auto" : "smooth", block: "start" });
  }

  function curveHTML(b) {
    var max = Math.max.apply(null, b.concat([1]));
    return '<div class="curve" role="img" aria-label="Mana curve of the nonland cards">' + b.map(function (n, i) {
      return "<div><b>" + (n || "") + '</b><i style="height:' + (n ? Math.max(5, Math.round(n / max * 66)) : 0) + '%"></i><em>' + (i === 7 ? "7+" : i) + "</em></div>";
    }).join("") + "</div>";
  }
  function colorsHTML(cc) {
    var tot = 0, keys = ["W", "U", "B", "R", "G", "C"];
    keys.forEach(function (k) { tot += cc[k]; });
    if (!tot) return '<p class="hint">No nonland cards to count.</p>';
    return '<div class="colorbar">' + keys.filter(function (k) { return cc[k]; }).map(function (k) { return '<i style="width:' + (cc[k] / tot * 100).toFixed(1) + "%;background:" + HEX[k] + '" title="' + NAME[k] + ": " + cc[k] + '"></i>'; }).join("") + "</div>" +
      '<ul class="tlegend">' + keys.filter(function (k) { return cc[k]; }).map(function (k) { return "<li>" + KD.mana("{" + k + "}") + "<span>" + NAME[k] + "</span><b>" + cc[k] + "</b></li>"; }).join("") + "</ul>";
  }
  function bracketHTML(a) {
    var b = a.bracket;
    if (!b) return "";
    var chips = function (list, cls) { return list.length ? '<div class="tchips">' + list.map(function (n) { return '<span class="badge ' + (cls || "") + '">' + esc(n) + "</span>"; }).join("") + "</div>" : ""; };
    return '<section class="panel panel--pad tbracket tbracket--' + b.level + '"><div class="tbracket__head"><div class="tbracket__num"><small>Bracket</small><b>' + (b.level === 4 ? "4+" : b.level === 2 ? "≤2" : "3") + "</b></div>" +
      '<div><p class="depth-tag">Estimated power level</p><h3>' + esc(b.name) + "</h3><p>" + esc(b.reasons.join(" · ")) + ".</p></div></div>" +
      (a.gameChangers.length ? '<p class="label">Game Changers</p>' + chips(a.gameChangers, "badge--gold") : "") +
      (a.tutors.length ? '<p class="label">Tutors</p>' + chips(a.tutors) : "") +
      (a.extraTurns.length ? '<p class="label">Extra turns</p>' + chips(a.extraTurns) : "") +
      (a.mld.length ? '<p class="label">Land destruction</p>' + chips(a.mld) : "") +
      '<p class="hint">From the list alone: two-card combos and how the deck is piloted also count toward a bracket.</p></section>';
  }
  function ratiosHTML(a) {
    var locked = !KD.signedIn;
    var rows = RATIOS.map(function (r) {
      var k = r[0], rec = a.rec[k], n = a[k], st = T.status(n, rec);
      var pct = rec.min ? Math.min(100, Math.round(n / rec.min * 100)) : 100;
      return '<div class="ratio is-' + (locked ? "locked" : st) + '"><div class="ratio__head"><b>' + r[1] + "</b>" +
        (locked ? '<span class="ratio__count"><svg class="i" aria-hidden="true"><use href="#i-key"/></svg></span>' : '<span class="ratio__count">' + n + "</span>") +
        '<span class="ratio__bar"><i style="width:' + (locked ? 0 : pct) + '%"></i></span>' +
        (locked ? "" : '<span class="ratio__st">' + (st === "good" ? "In range" : st === "low" ? "Low" : "High") + "</span>") +
        '<span class="ratio__rec">aim ' + esc(rec.label) + "</span></div>" + (locked ? "" : '<p class="hint">' + esc(rec.tip) + "</p>") + "</div>";
    }).join("");
    var summary = locked ? "" : a.gaps.length ? '<p class="ratio__sum is-low">Biggest gaps: ' + a.gaps.map(function (g) { return GAPWORD[g]; }).join(", ") + ".</p>" : '<p class="ratio__sum is-good">Solid foundation: every ratio is in the usual range for a ' + FORMAT[a.format] + " deck.</p>";
    return '<section class="panel panel--pad tratios' + (locked ? " is-locked" : "") + '"><div class="row row--between"><h3 class="label">Ratios for a ' + FORMAT[a.format] + " deck</h3></div>" + rows + summary +
      (locked ? '<div class="tratios__gate"><h3>See your ratios, free</h3><p>Create a free KrakenTheMeta account to see your ramp, card-draw, removal and board-wipe counts against the ' + FORMAT[a.format] + ' template, with the gaps flagged. Your list is saved and you come straight back to it.</p><a class="btn btn--lure" href="https://krakenthemeta.com/sign-in" data-unlock>Create a free account</a><a class="linkbtn" href="https://krakenthemeta.com/sign-in" data-unlock>I have an account: sign in</a></div>' : "") +
      "</section>";
  }

  function paint(a, res) {
    var cmd = a.commanders.join(" + ");
    out.innerHTML =
      '<div class="tsum"><p class="depth-tag">' + FORMAT[a.format] + " deck</p><h2>" + (cmd ? esc(cmd) : KD.fmt(a.totalCards) + " cards") + "</h2>" +
      (cmd ? '<p class="hint">' + KD.fmt(a.totalCards) + " cards, commander included</p>" : "") + "</div>" +
      '<div class="tstats">' +
        '<div><b>' + a.totalCards + "</b><span>Cards</span></div>" +
        "<div><b>" + a.lands + "</b><span>Lands</span></div>" +
        "<div><b>" + (a.nonlands ? a.avgMv.toFixed(2) : "–") + "</b><span>Avg. mana value</span></div>" +
        (a.bracket ? "<div><b>" + a.gameChangers.length + "</b><span>Game Changers</span></div>" : "<div><b>" + a.nonlands + "</b><span>Spells</span></div>") +
      "</div>" +
      '<div class="tgrid2"><section class="panel panel--pad dstats"><div><h4>Mana curve</h4>' + curveHTML(a.buckets) + '</div></section><section class="panel panel--pad dstats"><div><h4>Colors</h4>' + colorsHTML(a.colorCount) + "</div></section></div>" +
      bracketHTML(a) + ratiosHTML(a) +
      '<div class="tactions"><a class="btn btn--lure" href="https://krakenthemeta.com/sign-in" data-rebuild><svg class="i" aria-hidden="true"><use href="#i-sparkle"/></svg><span>' + (KD.signedIn && a.gaps.length ? "Fix the gaps with AI" : "Improve it with AI") + "</span></a>" +
        '<button class="btn btn--ghost" type="button" data-save><svg class="i" aria-hidden="true"><use href="#i-layers"/></svg><span>Save to my decks</span></button>' +
        '<button class="btn btn--ghost" type="button" data-odds><svg class="i" aria-hidden="true"><use href="#i-dice"/></svg><span>Test opening hands</span></button>' +
        '<button class="btn btn--ghost" type="button" data-swaps><svg class="i" aria-hidden="true"><use href="#i-coins"/></svg><span>Find budget swaps</span></button></div>' +
      KD.unmatchedHTML(res.unmatched) +
      '<p class="hint tnote">Counts come from each card\'s rules text on Scryfall: a fast, automated read rather than a verdict. A card can count twice (one that draws and ramps is in both).</p>';
  }

  out.addEventListener("click", function (e) {
    if (!last) return;
    var a = last.a;
    if (e.target.closest("[data-unlock]")) {
      panel.stashForSignIn("/mtg-deck-analyzer");
      KD.ga("analyzer_unlock", { format: a.format });
      return; // the link goes to sign-in
    }
    var rb = e.target.closest("[data-rebuild]");
    if (rb) {
      // 2026-10-03: this used to send only a sentence ("Rebuild my Commander deck…") and the
      // dashboard built an unrelated new deck. Now the list itself goes over and opens in
      // "Improve this deck" with the gaps as the goal; nothing is replaced until the player picks.
      var gaps = a.gaps.filter(function (g) { return g !== "lands"; }).map(function (g) { return "more " + GAPWORD[g]; });
      var chips = a.gaps.map(function (g) { return g === "lands" ? "mana" : g === "wipe" ? null : g; }).filter(Boolean).slice(0, 3);
      var goal = gaps.length ? "Fix the gaps the analyzer found: " + gaps.join(", ") + "." : "";
      try {
        localStorage.setItem("ktm_pending_upgrade", JSON.stringify({
          name: a.commanders.length ? a.commanders[0].split(",")[0] + " deck" : FORMAT[a.format] + " deck",
          format: a.format === "commander" ? "commander" : "standard",
          list: T.listText(last.parsed.rows), goal: goal, goals: chips.length ? chips : ["weak"], at: Date.now(), from: "analyzer"
        }));
      } catch (err) { KD.toast("Your browser blocked storage, so copy the list and import it in the dashboard.", "err"); e.preventDefault(); return; }
      rb.href = KD.buildUrl();
      KD.ga("analyzer_rebuild", { format: a.format, gaps: a.gaps.join(",") });
      return;
    }
    if (e.target.closest("[data-save]")) {
      var name = a.commanders.length ? a.commanders[0].split(",")[0] + " deck" : FORMAT[a.format] + " deck";
      try {
        localStorage.setItem("ktm_pending_import", JSON.stringify({ name: name, format: a.format === "commander" ? "commander" : "standard", list: T.listText(last.parsed.rows), at: Date.now(), from: "analyzer" }));
      } catch (err) { KD.toast("Your browser blocked storage, so copy the list and import it in the dashboard.", "err"); return; }
      KD.ga("analyzer_save", { signed_in: KD.signedIn });
      location.href = KD.signedIn ? "/dashboard" : "https://krakenthemeta.com/sign-in";
      return;
    }
    if (e.target.closest("[data-odds]")) { KD.ga("analyzer_to_odds"); panel.handoff("kraken_pending_odds", "/mtg-odds"); return; }
    if (e.target.closest("[data-swaps]")) { KD.ga("analyzer_to_swaps"); panel.handoff("kraken_pending_swaps", "/mtg-budget-swaps"); }
  });
})();
